// React
import { useContext, useEffect, useState } from "react"
import { useHistory, useLocation, useParams } from "react-router-dom"

// Component
import { Card, Col, FormFile, Row } from "react-bootstrap"
import { AuthContext, DateConvert, RupiahConvert } from "utilities"
import {
  ActionButton,
  Alert,
  AlertAlreadyStockOpname,
  BackButton,
  CRUDLayout,
  DataStatus,
  Input,
  NumberFormat,
  SelectSearch
} from "../../../../components"

// Form
import { Formik } from "formik"
import * as Yup from "yup"

// API
import Axios from "axios"
import { PenerimaanBarangApi } from "../../../../api"

// File Uploader
import ImageViewer from "react-simple-image-viewer"
import { dotToComma } from "./components"

const UbahPenerimaanBarang = ({ setNavbarTitle }) => {
  const title = "Penerimaan Barang"
  const { state } = useContext(AuthContext)
  const history = useHistory()
  const { id } = useParams()
  const location = useLocation()

  // STATE LOADING
  const [isLoading, setIsLoading] = useState(false)

  // STATE MENAMPUNG DATA
  const [data, setData] = useState({
    penerimaan_barang: []
  })
  const [dataAtribut, setDataAtribut] = useState({
    gudang: [],
    karyawan: [],
    satuan: []
  })
  const [dataStore, setDataStore] = useState([])
  const [selectedFileNIK, setSelectedFileNIK] = useState()
  const [nameFileNIK, setNameFileNIK] = useState("")

  // ALERT STATE
  const [showAlert, setShowAlert] = useState(false)

  // KONFIGURASI ALERT
  const [alertConfig, setAlertConfig] = useState({
    variant: "primary",
    text: ""
  })

  // FUNCTION GET DATA DARI SERVER
  const getData = () => {
    setIsLoading(true)

    Axios.all([
      PenerimaanBarangApi.getSinglePenerimaan("id_penerimaan_barang", id),
      PenerimaanBarangApi.getAtribut("gudang"),
      PenerimaanBarangApi.getAtribut("karyawan"),
      PenerimaanBarangApi.getAtribut("satuan")
    ])
      .then(
        Axios.spread((data, gudang, karyawan, satuan) => {
          setData(data.data.data)
          setDataAtribut({
            gudang: gudang.data.data,
            karyawan: karyawan.data.data,
            satuan: satuan.data.data
          })
        })
      )
      .catch((err) => alert(err.response.data.message))
      .finally(() => setIsLoading(false))
  }

  // FUNGSI UNTUK MENCARI NAMA JABATAN BERDASARKAN id_jabatan
  const findNamaKaryawan = (id_karyawan) => {
    return (
      // eslint-disable-next-line
      dataAtribut.karyawan.find((val) => val.id_karyawan == id_karyawan)
        ?.nama_karyawan ?? "Pilih Petugas"
    )
  }

  const findGudangPenerimaan = (id_gudang) => {
    return (
      // eslint-disable-next-line
      dataAtribut.gudang.find((val) => val.id_gudang == id_gudang)
        ?.nama_gudang ?? "Pilih Gudang"
    )
  }

  // ON COMPONENT MOUNT
  useEffect(() => {
    // setIsLoading(true)
    setNavbarTitle(title) // SET JUDUL NAVBAR

    getData() // GET DATA DARI SERVER

    // setFilesUpload([{ privew: data.foto_surat_jalan }])
    // eslint-disable-next-line
  }, [])

  const InputFileNIK = () => {
    const [preview, setPreview] = useState()

    const [isViewerOpen, setIsViewerOpen] = useState(false)
    const filesViewer = [preview]

    useEffect(() => {
      if (!selectedFileNIK) {
        setPreview(undefined)
        return
      }

      const objectUrl = URL.createObjectURL(selectedFileNIK)
      setPreview(objectUrl)

      return () => URL.revokeObjectURL(objectUrl)

      // eslint-disable-next-line
    }, [selectedFileNIK])

    const onSelectFile = (e) => {
      if (!e.target.files || e.target.files.length === 0) {
        setSelectedFileNIK(undefined)
        setNameFileNIK(undefined)

        return
      }

      setSelectedFileNIK(e.target.files[0])
      setNameFileNIK(e.target.files[0].name)
    }

    const closeImageViewer = () => {
      setIsViewerOpen(false)
    }
    return (
      <>
        <small>Upload Foto Bukti Penerimaan Barang</small>
        <FormFile custom style={{ zIndex: 0 }}>
          <FormFile.Input size="sm" onChange={onSelectFile} accept="image/*" />
          <FormFile.Label style={{ fontSize: 14 }}>
            {nameFileNIK ? nameFileNIK : "Pilih Gambar"}
          </FormFile.Label>
        </FormFile>
        {Boolean(selectedFileNIK || data.foto_surat_jalan) && (
          <img
            src={selectedFileNIK ? preview : data.foto_surat_jalan}
            onClick={() => {
              setIsViewerOpen(true)
            }}
            alt=""
            className="mt-4 mb-4 img-fluid"
          />
        )}
        {isViewerOpen && (
          <ImageViewer
            src={filesViewer}
            currentIndex={0}
            disableScroll={false}
            onClose={closeImageViewer}
          />
        )}
      </>
    )
  }

  // INITIAL VALUES FORM TAMBAH DATA TIPE BARANG JADI
  const formInitialValues = {
    tgl_penerimaan_barang: data.tgl_penerimaan_barang,
    no_penerimaan_barang: data.no_penerimaan_barang,
    id_penerimaan_barang: id,
    id_purchase_order_detail: data.id_purchase_order_detail,
    no_surat_jalan: data.no_surat_jalan,
    petugas_penerimaan: data.petugas_penerimaan,
    gudang_penerimaan: data.gudang_penerimaan,
    qty_beli: data.qty_beli,
    id_satuan_beli: data.id_satuan_beli,
    qty_pakai: data.qty_pakai,
    id_satuan_pakai: data.id_satuan_pakai,
    nilai_konversi: data?.nilai_konversi ?? 0
  }

  // FORMIK VALIDATION SCHEMA TIPE BARANG JADI DENGAN YUP VALIDATION
  const formValidationSchema = Yup.object().shape({
    tgl_penerimaan_barang: Yup.string().required("Tanggal wajib diisi"),
    no_surat_jalan: Yup.string().required("No. Surat Jalan wajib diisi"),
    petugas_penerimaan: Yup.string().required("Pilih Petugas").nullable(),
    gudang_penerimaan: Yup.string().required("Pilih Gudang").nullable()
  })

  // KIRIM UPDATE DATA KE SERVER
  const formSubmitHandler = (values, { setSubmitting }) => {
    if (!selectedFileNIK) {
      PenerimaanBarangApi.update({
        ...values,
        id_pengaju: state.id
      })
        .then(() => {
          history.push("/inventory/transaksi/penerimaan-barang", {
            registerAlertConfig: {
              variant: "primary",
              text: "Tambah data berhasil!"
            },
            ...location.state
          })
        })
        .catch((err) => {
          setAlertConfig({
            variant: "danger",
            text: `Tambah data gagal! (${err.response.data.message})`
          })
        })
    } else {
      const NIK = [selectedFileNIK]
      const formData = new FormData()

      NIK.reduce((_acc, file, _index) => {
        formData.append("file", file)
        return file
      }, {})

      PenerimaanBarangApi.upload(formData).then((data) => {
        let valueUpload = {
          ...values,
          id_pengaju: state.id,
          foto_surat_jalan: data.data.data
        }

        PenerimaanBarangApi.update(valueUpload)
          .then(() => {
            history.push("/inventory/transaksi/penerimaan-barang", {
              registerAlertConfig: {
                variant: "primary",
                text: "Tambah data berhasil!"
              },
              ...location.state
            })
          })
          .catch((err) => {
            setAlertConfig({
              variant: "danger",
              text: `Tambah data gagal! (${err.response.data.message})`
            })
          })
      })
    }
  }
  return (
    <CRUDLayout>
      {/* Alert */}
      <Alert
        show={showAlert}
        showCloseButton={true}
        variant={alertConfig.variant}
        text={alertConfig.text}
        onClose={() => setShowAlert(false)}
      />

      <Card>
        <Card.Header className="d-flex justify-content-between align-items-center">
          <b>Ubah Data Penerimaan Barang</b>
          <BackButton
            size="sm"
            onClick={() =>
              history.push(
                "/inventory/transaksi/penerimaan-barang",
                location.state
              )
            }
          />
        </Card.Header>
        {isLoading ? (
          <DataStatus loading={isLoading} text="Memuat Data" />
        ) : (
          <Formik
            enableReinitialize={true}
            initialValues={formInitialValues}
            validationSchema={formValidationSchema}
            onSubmit={formSubmitHandler}>
            {({
              values,
              errors,
              touched,
              isSubmitting,
              handleChange,
              handleSubmit,
              setFieldValue
            }) => {
              const harga =
                parseFloat(data.harga_kesepakatan ?? 0) +
                parseFloat(data.harga_kesepakatan_biaya_angkut ?? 0)

              const hargaKonversi = values.qty_pakai
                ? parseFloat(harga / values.nilai_konversi)
                : 0
              return (
                <form onSubmit={handleSubmit}>
                  <Card.Body>
                    <Row className="mb-3">
                      <Col sm="6">
                        <Row>
                          <Col md="4">
                            <small>Tgl. Purchase Order</small>
                          </Col>
                          <Col md="8">
                            <small>
                              {" "}
                              :{" "}
                              {
                                DateConvert(new Date(data.tgl_purchase_order))
                                  .detail
                              }
                            </small>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="4">
                            <small>No. Purchase Order</small>
                          </Col>
                          <Col md="8">
                            <small> : {data.no_purchase_order}</small>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="4">
                            <small>Vendor</small>
                          </Col>
                          <Col md="8">
                            <small> : {data.nama_vendor}</small>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="4">
                            <small>Item Barang</small>
                          </Col>
                          <Col md="8">
                            <small> : {data.nama_item}</small>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="4">
                            <small>Proyek</small>
                          </Col>
                          <Col md="8">
                            <small> : {data.nama_proyek ?? "-"}</small>
                          </Col>
                        </Row>
                      </Col>

                      <Col sm="6">
                        <Row>
                          <Col md="4">
                            <small>Qty Purchase Order</small>
                          </Col>
                          <Col md="8">
                            <small>
                              {" "}
                              : {parseFloat(data.qty_order).toPrecision() ??
                                0}{" "}
                              {data.kode_satuan_beli}
                            </small>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="4">
                            <small>Qty Telah Diterima</small>
                          </Col>
                          <Col md="8">
                            <small>
                              {" "}
                              :{" "}
                              {data.qty_diterima
                                ? parseFloat(data.qty_diterima).toPrecision()
                                : 0}{" "}
                              {data.kode_satuan_beli}
                            </small>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="4">
                            <small>Qty Sisa</small>
                          </Col>
                          <Col md="8">
                            <small>
                              {" "}
                              :{" "}
                              {data.qty_order && data.qty_diterima
                                ? parseFloat(
                                    data.qty_order - data.qty_diterima
                                  ).toPrecision()
                                : 0}{" "}
                              {data.kode_satuan_beli}
                            </small>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="4">
                            <small>Keterangan PO</small>
                          </Col>
                          <Col md="8">
                            <small>
                              : {data.keterangan_po ? data.keterangan_po : "-"}
                            </small>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <hr></hr>

                    <Row>
                      <Col md>
                        <Row>
                          <Col lg>
                            <Input
                              label="Tgl. Penerimaan Barang"
                              type="date"
                              name="tgl_penerimaan_barang"
                              value={values.tgl_penerimaan_barang}
                              onChange={(val) => {
                                setFieldValue(
                                  "tgl_penerimaan_barang",
                                  val.target.value
                                )
                                // getDataNo(val.target.value)
                                // setDataStore({
                                //     ...dataStore,
                                //     tgl_penerimaan_barang: val.target.value,
                                // })
                              }}
                              error={
                                errors.tgl_penerimaan_barang &&
                                touched.tgl_penerimaan_barang &&
                                true
                              }
                              errorText={errors.tgl_penerimaan_barang}
                            />
                          </Col>

                          <Col lg>
                            <Input
                              label="No. Penerimaan Barang"
                              type="text"
                              readOnly={true}
                              value={values.no_penerimaan_barang}
                            />
                          </Col>
                        </Row>

                        <Input
                          label="No. Surat Jalan Dari Vendor"
                          type="text"
                          name="no_surat_jalan"
                          value={values.no_surat_jalan}
                          onChange={(e) => {
                            setFieldValue("no_surat_jalan", e.target.value)
                            // setDataStore({
                            //     ...dataStore,
                            //     no_surat_jalan: e.target.value,
                            // })
                          }}
                          error={
                            errors.no_surat_jalan &&
                            touched.no_surat_jalan &&
                            true
                          }
                          errorText={errors.no_surat_jalan}
                        />

                        <SelectSearch
                          label="Gudang Penerimaan Barang"
                          name="gudang_penerimaan"
                          onChange={(val) => {
                            setFieldValue("gudang_penerimaan", val.value)
                            // setDataStore({
                            //     ...dataStore,
                            //     gudang_penerimaan: val.value,
                            // })
                          }}
                          option={dataAtribut.gudang.map((val) => {
                            return {
                              value: val.id_gudang,
                              label: val.nama_gudang
                            }
                          })}
                          defaultValue={{
                            value: values.gudang_penerimaan,
                            label: findGudangPenerimaan(
                              values.gudang_penerimaan
                            )
                          }}
                          error={
                            errors.gudang_penerimaan &&
                            touched.gudang_penerimaan &&
                            true
                          }
                          errorText={errors.gudang_penerimaan}
                        />

                        <SelectSearch
                          label="Petugas Penerimaan"
                          name="petugas_penerimaan"
                          onChange={(val) => {
                            setFieldValue("petugas_penerimaan", val.value)
                            setDataStore({
                              ...dataStore,
                              petugas_penerimaan: val.value
                            })
                          }}
                          option={dataAtribut.karyawan.map((val) => {
                            return {
                              value: val.id_karyawan,
                              label: val.nama_karyawan
                            }
                          })}
                          defaultValue={{
                            value: values.petugas_penerimaan,
                            label: findNamaKaryawan(values.petugas_penerimaan)
                          }}
                          error={
                            errors.petugas_penerimaan &&
                            touched.petugas_penerimaan &&
                            true
                          }
                          errorText={errors.petugas_penerimaan}
                        />

                        <small>Qty. Penerimaan (Dalam Satuan Beli)</small>
                        <Row>
                          <Col lg>
                            <NumberFormat
                              label=""
                              className="text-right"
                              value={dotToComma(values.qty_beli)}
                              defaultValue={values.qty_beli}
                              onChange={(value) => {
                                const konversi = data?.nilai_konversi
                                  ? parseFloat(data.nilai_konversi)
                                  : 1

                                const qty_pakai = value * konversi
                                setFieldValue("qty_beli", value)
                                setFieldValue("qty_pakai", qty_pakai)
                              }}
                            />
                          </Col>

                          <Col lg>
                            <Input
                              type="text"
                              value={data?.nama_satuan_beli ?? "-"}
                              readOnly={true}
                            />
                          </Col>
                        </Row>

                        <Input
                          label="Harga Barang Per Satuan Beli"
                          type="text"
                          className="text-right"
                          value={
                            data?.harga_kesepakatan
                              ? RupiahConvert(parseFloat(harga).toString())
                                  .getWithComa
                              : "Rp0"
                          }
                          readOnly={true}
                        />

                        <small>Qty. Penerimaan (Dalam Satuan Pakai)</small>
                        <Row>
                          <Col lg>
                            <NumberFormat
                              label=""
                              className="text-right"
                              value={dotToComma(values.qty_pakai)}
                              defaultValue={values.qty_pakai}
                              onChange={(value) => {
                                const konversi = data?.nilai_konversi
                                  ? parseInt(data.nilai_konversi)
                                  : 1
                                const qty_beli = value / konversi
                                setFieldValue("qty_pakai", value)
                                setFieldValue("qty_beli", qty_beli)
                              }}
                            />
                          </Col>

                          <Col lg>
                            <Input
                              type="text"
                              value={data?.nama_satuan_pakai ?? "-"}
                              readOnly={true}
                            />
                          </Col>
                        </Row>

                        <Input
                          label="Harga Barang Per Satuan Pakai"
                          type="text"
                          className="text-right"
                          value={
                            data?.harga_kesepakatan && data?.nilai_konversi
                              ? RupiahConvert(String(parseFloat(hargaKonversi)))
                                  .getWithComa
                              : "Rp0"
                          }
                          readOnly={true}
                        />
                      </Col>

                      <Col md>
                        <InputFileNIK />
                      </Col>

                      <AlertAlreadyStockOpname
                        tanggal={values?.tgl_penerimaan_barang}
                      />
                    </Row>
                  </Card.Body>
                  <Card.Footer>
                    <div className="text-right">
                      <ActionButton
                        type="action"
                        className="btn btn-primary text-white"
                        size="md"
                        text="Simpan"
                        loading={isSubmitting}
                      />
                    </div>
                  </Card.Footer>
                </form>
              )
            }}
          </Formik>
        )}
      </Card>
    </CRUDLayout>
  )
}
export default UbahPenerimaanBarang
